import { useVillaSearchPassengerCount } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.hook";
import { VillaSearchPassengerCountPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Chips } from "@website/ui/chips";
import { ListItem } from "@website/ui/list-item";
import { MiniChips } from "@website/ui/mini-chips";
import { MiniPopover } from "@website/ui/mini-popover";
import { TextField } from "@website/ui/text-field";
import { FC } from "react";

export const VillaSearchPassengerCount: FC<
  VillaSearchPassengerCountPropertiesType
> = (properties) => {
  const { searchType, size } = properties;
  const {
    list,
    chipsProps,
    popoverProps,
    submitButtonProps,
    miniChipsPassenger,
    miniChipsChildren,
    validation
  } = useVillaSearchPassengerCount(properties);
  const { isMobile } = useViewPort();

  return (
    <div className="relative">
      {searchType === "villa" ? (
        <TextField
          EndIcon={<MaterialIcon name="arrow_drop_down" />}
          StartIcon={<MaterialIcon name="group" variant="outlined" />}
          className="text-on-surface-medium-emphasis"
          fullWidth
          hasFocusStyle={!isMobile}
          inputMode="none"
          label="تعداد مسافر"
          onClick={chipsProps.onClick}
          size={size}
          value={chipsProps.text}
        />
      ) : (
        <Chips {...chipsProps} />
      )}
      <MiniPopover {...popoverProps}>
        <div className="flex flex-1 flex-col overflow-hidden">
          <div className="flex flex-1 overflow-hidden">
            <div className="flex-1 overflow-y-auto">
              {list.map((item) => (
                <ListItem key={item.title} {...item} />
              ))}
            </div>
          </div>
          {validation.isPassengerDisabled && (
            <div className="text-caption px-4 pt-7">
              <MiniChips
                StartIcon={
                  <MaterialIcon
                    className="text-base"
                    name="info"
                    variant="outlined"
                  />
                }
                color="error"
                text={miniChipsPassenger.text}
                variant="text"
              />
            </div>
          )}
          {validation.isChildrenDisabled && !validation.isPassengerDisabled && (
            <div className="text-caption px-4 pt-7">
              <MiniChips
                StartIcon={
                  <MaterialIcon
                    className="text-base"
                    name="info"
                    variant="outlined"
                  />
                }
                color="error"
                text={miniChipsChildren.text}
                variant="text"
              />
            </div>
          )}
          <div className="px-6 pb-6 pt-5">
            <Button
              disabled={validation.isSubmitDisabled}
              {...submitButtonProps}
            >
              {submitButtonProps.submitText}
            </Button>
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};
